import { render, staticRenderFns } from "./SelectMultiple.vue?vue&type=template&id=4b3382da&scoped=true"
import script from "./SelectMultiple.vue?vue&type=script&lang=js"
export * from "./SelectMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3382da",
  null
  
)

export default component.exports